// extracted by mini-css-extract-plugin
export var alertIcon = "_sl-0";